import React, { useState } from 'react';

import lotto649Img from './lotto-649-logo.png';
import lottoMaxImg from './lottomax-w.png';


/* =========================================================
   Lotto 6/49 Logo
========================================================= */

export const Lotto649Logo = ({
  height = 38,
  style = {},
}) => (
  <img
    src={lotto649Img}
    alt="Lotto 6/49"
    style={{
      height: `${height}px`,
      width: 'auto',
      maxWidth: '190px',
      objectFit: 'contain',
      display: 'block',
      ...style,
    }}
  />
);


/* =========================================================
   Lotto MAX Logo
========================================================= */

export const LottoMaxLogo = ({
  height = 38,
  style = {},
}) => (
  <img
    src={lottoMaxImg}
    alt="Lotto MAX"
    style={{
      height: `${height}px`,
      width: 'auto',
      maxWidth: '190px',
      objectFit: 'contain',
      display: 'block',
      ...style,
    }}
  />
);


/* =========================================================
   Roulette Logo
========================================================= */

export const RouletteLogo = ({
  height = 38,
  style = {},
}) => (
  <svg
    height={height}
    viewBox="0 0 135 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      height: `${height}px`,
      width: 'auto',
      minWidth: '70px',
      display: 'block',
      ...style,
    }}
  >

    <text
      x="0"
      y="26"
      fill="#FFFFFF"
      fontSize="22"
      fontWeight="900"
      fontFamily="Arial, sans-serif"
      fontStyle="italic"
    >
      Roulette
    </text>


    <g transform="translate(100, 2) scale(1.25)">

      <circle
        cx="20"
        cy="20"
        r="19"
        fill="#78350F"
        stroke="#F59E0B"
        strokeWidth="1.5"
      />

      <circle
        cx="20"
        cy="20"
        r="16"
        fill="#1E293B"
      />

      <circle
        cx="20"
        cy="20"
        r="13"
        fill="none"
        stroke="#EF4444"
        strokeWidth="5"
        strokeDasharray="5 5"
      />

      <circle
        cx="20"
        cy="20"
        r="13"
        fill="none"
        stroke="#000000"
        strokeWidth="5"
        strokeDasharray="5 5"
        strokeDashoffset="5"
      />

      <circle
        cx="20"
        cy="20"
        r="7"
        fill="#F59E0B"
      />

      <circle
        cx="20"
        cy="20"
        r="3"
        fill="#FFFBEB"
      />

    </g>


    <text
      x="2"
      y="75"
      fill="#38BDF8"
      fontSize="40"
      fontWeight="900"
      fontFamily="Arial, sans-serif"
    >
      37
    </text>


    <text
      x="56"
      y="73"
      fill="#94A3B8"
      fontSize="16"
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
    >
      SLOTS
    </text>

  </svg>
);


/* =========================================================
   Combined Logo
========================================================= */

export const CombinedLogo = ({
  height = 38,
  style = {},
}) => {

  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',

        gap: '12px',

        padding: '7px 16px',

        backgroundColor: '#0d4385',

        borderRadius: '30px',

        boxShadow: hovered
          ? '0 6px 18px rgba(13, 67, 133, 0.50)'
          : '0 3px 10px rgba(0, 0, 0, 0.25)',

        transform: hovered
          ? 'scale(1.03)'
          : 'scale(1)',

        transition: 'all 0.2s ease',

        cursor: 'pointer',

        boxSizing: 'border-box',

        maxWidth: '100%',

        ...style,
      }}
    >

      <Lotto649Logo height={height} />

      <div
        style={{
          width: '1px',
          height: `${height * 0.58}px`,
          backgroundColor: 'rgba(255, 255, 255, 0.30)',
        }}
      />

      <LottoMaxLogo height={height} />

      <div
        style={{
          width: '1px',
          height: `${height * 0.58}px`,
          backgroundColor: 'rgba(255, 255, 255, 0.30)',
        }}
      />

      <RouletteLogo height={height} />

    </div>
  );
};